(function () {
  function formatPrice(price) {
    if (!price && price !== 0) return '';

    if (typeof price === 'string') {
      return price;
    }

    if (typeof price === 'number') {
      return '$' + (price / 100).toFixed(2) + ' USD';
    }

    return '';
  }

  function getImage(product) {
    if (!product.image) return '';

    if (typeof product.image === 'string') {
      return product.image;
    }

    if (typeof product.image === 'object') {
      return product.image.url || product.image.src || '';
    }

    return '';
  }

  function ensureProductType(form) {
    if (!form.querySelector('input[name="type"]')) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'type';
      hidden.value = 'product';
      form.appendChild(hidden);
    }
  }

  function setupSearchForm(form) {
    if (!form || form.classList.contains('la-live-search-form')) return;

    var input = form.querySelector('input[type="search"][name="q"], input[name="q"]');
    if (!input) return;

    form.classList.add('la-live-search-form');
    ensureProductType(form);

    var box = document.createElement('div');
    box.className = 'la-live-search-results';
    form.appendChild(box);

    var timer = null;
    var controller = null;

    input.addEventListener('input', function () {
      var q = input.value.trim();

      clearTimeout(timer);

      if (controller) {
        controller.abort();
        controller = null;
      }

      if (q.length < 2) {
        box.classList.remove('is-active');
        box.innerHTML = '';
        return;
      }

      timer = setTimeout(function () {
        controller = new AbortController();

        var url =
          '/search/suggest.json?q=' +
          encodeURIComponent(q) +
          '&resources[type]=product' +
          '&resources[limit]=8' +
          '&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=title,product_type,variants.title,vendor';

        fetch(url, { signal: controller.signal })
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            var products =
              data &&
              data.resources &&
              data.resources.results &&
              data.resources.results.products
                ? data.resources.results.products
                : [];

            if (!products.length) {
              box.innerHTML = '<div class="la-live-search-empty">No products found</div>';
              box.classList.add('is-active');
              return;
            }

            var html = products
              .map(function (p) {
                var img = getImage(p);
                var price = formatPrice(p.price);
                var title = p.title || '';
                var productUrl = p.url || '#';

                return (
                  '<a class="la-live-search-item" href="' + productUrl + '">' +
                    (img ? '<img src="' + img + '" alt="">' : '<div></div>') +
                    '<div>' +
                      '<div class="la-live-search-title">' + title + '</div>' +
                      (price ? '<div class="la-live-search-price">' + price + '</div>' : '') +
                    '</div>' +
                  '</a>'
                );
              })
              .join('');

            html +=
              '<a class="la-live-search-footer" href="/search?type=product&q=' +
              encodeURIComponent(q) +
              '&options%5Bprefix%5D=last">View all results</a>';

            box.innerHTML = html;
            box.classList.add('is-active');
          })
          .catch(function (err) {
            if (err.name !== 'AbortError') {
              box.classList.remove('is-active');
            }
          });
      }, 250);
    });

    form.addEventListener('submit', function () {
      ensureProductType(form);
    });

    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) {
        box.classList.remove('is-active');
      }
    });
  }

  function initLiveSearch() {
    document.querySelectorAll('form[action="/search"], form[action*="/search"]').forEach(setupSearchForm);
  }

  document.addEventListener('DOMContentLoaded', initLiveSearch);
  document.addEventListener('shopify:section:load', initLiveSearch);
})();